@for (activity of activities; track activity; let i = $index) {
  <div class="activity">
    <span
      ><language
        [key]="'ActivityType' + activity.className"
        [defaultValue]="camelCaseToNormal(activity.className)"
      ></language>
      @if (activity.ActivityDisplayName) {
        <span>: {{ activity.ActivityDisplayName }}</span>
      }
    </span>
    @if (editEnabled) {
      <div class="buttons">
        <button mat-icon-button (click)="moveUp(i)" [disabled]="i == 0">
          <mat-icon aria-label="Move up">keyboard_arrow_up</mat-icon>
        </button>
        <button mat-icon-button (click)="moveDown(i)" [disabled]="i == activities.length - 1">
          <mat-icon aria-label="Move down">keyboard_arrow_down</mat-icon>
        </button>
        <button mat-icon-button (click)="delete(i)">
          <mat-icon aria-label="Delete">close</mat-icon>
        </button>
        <button mat-icon-button (click)="edit(i)">
          <mat-icon aria-label="Edit">edit</mat-icon>
        </button>
      </div>
    }
  </div>
}
@if (editEnabled) {
  <div class="add-row">
    <mat-form-field>
      <mat-select
        [placeholder]="translationObs('ActivityAddTypeSelect', 'Select Activity Type') | async"
        #addType
      >
        @if (activityTypeAllowed(ActivityType.AddDelay)) {
          <mat-option
            [value]="ActivityType.AddDelay"
            matTooltipShowDelay="300"
            matTooltipClass="activity-type-desc-tooltip"
            [matTooltip]="
              translationObs(
                'ActivityTypeAddDelayDescription',
                'Add a delay / wait to the workflow execution.'
              ) | async
            "
          >
            <language key="ActivityTypeAddDelay" defaultValue="Add Delay"></language>
          </mat-option>
        }
        @if (activityTypeAllowed(ActivityType.CreateResource)) {
          <mat-option
            [value]="ActivityType.CreateResource"
            matTooltipShowDelay="300"
            matTooltipClass="activity-type-desc-tooltip"
            [matTooltip]="
              translationObs(
                'ActivityTypeCreateResourceDescription',
                'Create a new resource and assign attribute values.'
              ) | async
            "
          >
            <language key="ActivityTypeCreateResource" defaultValue="Create Resource"></language>
          </mat-option>
        }
        @if (activityTypeAllowed(ActivityType.DeleteResources)) {
          <mat-option
            [value]="ActivityType.DeleteResources"
            matTooltipShowDelay="300"
            matTooltipClass="activity-type-desc-tooltip"
            [matTooltip]="
              translationObs(
                'ActivityTypeDeleteResourcesDescription',
                'Delete one or more resources.'
              ) | async
            "
          >
            <language key="ActivityTypeDeleteResources" defaultValue="Delete Resources"></language>
          </mat-option>
        }
        @if (activityTypeAllowed(ActivityType.GenerateUniqueValue)) {
          <mat-option
            [value]="ActivityType.GenerateUniqueValue"
            matTooltipShowDelay="300"
            matTooltipClass="activity-type-desc-tooltip"
            [matTooltip]="
              translationObs(
                'ActivityTypeGenerateUniqueValueDescription',
                'Generate a unique string value based on defined criteria.'
              ) | async
            "
          >
            <language
              key="ActivityTypeGenerateUniqueValue"
              defaultValue="Generate Unique Value"
            ></language>
          </mat-option>
        }
        @if (activityTypeAllowed(ActivityType.IDGenerator)) {
          <mat-option
            [value]="ActivityType.IDGenerator"
            matTooltipShowDelay="300"
            matTooltipClass="activity-type-desc-tooltip"
            [matTooltip]="
              translationObs(
                'ActivityTypeIDGeneratorDescription',
                'Generate IDs, multiple queues possible, unique with multiple fimservice machines.'
              ) | async
            "
          >
            <language key="ActivityTypeIDGenerator" defaultValue="ID Generator"></language>
          </mat-option>
        }
        @if (activityTypeAllowed(ActivityType.RequestApproval)) {
          <mat-option
            [value]="ActivityType.RequestApproval"
            matTooltipShowDelay="300"
            matTooltipClass="activity-type-desc-tooltip"
            [matTooltip]="
              translationObs(
                'ActivityTypeRequestApprovalDescription',
                'Seek approval from specific approvers by mail.'
              ) | async
            "
          >
            <language key="ActivityTypeRequestApproval" defaultValue="Request Approval"></language>
          </mat-option>
        }
        @if (activityTypeAllowed(ActivityType.RunPowerShellScript)) {
          <mat-option
            [value]="ActivityType.RunPowerShellScript"
            matTooltipShowDelay="300"
            matTooltipClass="activity-type-desc-tooltip"
            [matTooltip]="
              translationObs(
                'ActivityTypeRunPowerShellScriptDescription',
                'Run a PowerShell script from workflow.'
              ) | async
            "
          >
            <language
              key="ActivityTypeRunPowerShellScript"
              defaultValue="Run PowerShell Script"
            ></language>
          </mat-option>
        }
        @if (activityTypeAllowed(ActivityType.SendEmailNotification)) {
          <mat-option
            [value]="ActivityType.SendEmailNotification"
            matTooltipShowDelay="300"
            matTooltipClass="activity-type-desc-tooltip"
            [matTooltip]="
              translationObs(
                'ActivityTypeSendEmailNotificationDescription',
                'Send Email Notification'
              ) | async
            "
          >
            <language
              key="ActivityTypeSendEmailNotification"
              defaultValue="Send Email Notification"
            ></language>
          </mat-option>
        }
        @if (activityTypeAllowed(ActivityType.UpdateResources)) {
          <mat-option
            [value]="ActivityType.UpdateResources"
            matTooltipShowDelay="300"
            matTooltipClass="activity-type-desc-tooltip"
            [matTooltip]="
              translationObs(
                'ActivityTypeUpdateResourcesDescription',
                'Update multiple attributes on one or more resources.'
              ) | async
            "
          >
            <language key="ActivityTypeUpdateResources" defaultValue="Update Resources"></language>
          </mat-option>
        }
        @if (activityTypeAllowed(ActivityType.VerifyRequest)) {
          <mat-option
            [value]="ActivityType.VerifyRequest"
            matTooltipShowDelay="300"
            matTooltipClass="activity-type-desc-tooltip"
            [matTooltip]="
              translationObs(
                'ActivityTypeVerifyRequestDescription',
                'Enforce a defined set of conditions for a request and return a customizable denial message when a condition is not satisfied.'
              ) | async
            "
          >
            <language key="ActivityTypeVerifyRequest" defaultValue="Verify Request"></language>
          </mat-option>
        }
        <mat-option
          [value]="ActivityType.Custom"
          matTooltipShowDelay="300"
          matTooltipClass="activity-type-desc-tooltip"
          [matTooltip]="
            translationObs('ActivityTypeCustomDescription', 'Add a custom activity as XML.') | async
          "
        >
          <language key="ActivityTypeCustom" defaultValue="Custom"></language>
        </mat-option>
      </mat-select>
    </mat-form-field>
    <button mat-raised-button color="primary" (click)="add(addType.value)">
      <language key="ActivityAdd" defaultValue="Add Activity"></language>
    </button>
  </div>
}
